import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

const SellerHome = () => {
  return null
}

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  const actions = {}

  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

// Overrides default preFetcher in app.server.js
SellerHome.preFetcher = ({ store, req, res }) => {
  res.redirect('/seller/dashboard')
  return Promise.resolve()
}

SellerHome.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const MappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SellerHome)

export default MappedComponent
